import React from 'react';
import { Card, CardContent, Typography, Grid, Divider, Box, Chip } from '@mui/material';
import { Person, CalendarToday, AccountBalance, Description } from '@mui/icons-material';

const RequestInfo = ({ rowData }) => {
  const InfoRow = ({ label, value }) => (
    <Grid item xs={12} sm={6}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ fontWeight: 400 }}>
        {value || 'N/A'}
      </Typography>
    </Grid>
  );

  return (
    <Card
      sx={{
        width: '100%',
        margin: 'auto',
        boxShadow: 3,
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: 2,
        }}
      >
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
          Refund Request Details
        </Typography>
      </Box>

      <CardContent sx={{ p: 3 }}>
        {/* Request Information Section */}
        <Box sx={{ mb: 3 }}>
          {/* <Typography
            variant="h6"
            sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}
          >
            <Description sx={{ fontSize: 20, mr: 1, verticalAlign: 'middle' }} />
            Request Information
          </Typography> */}
          <Grid container spacing={2}>
            <InfoRow label="Reason" value={rowData?.refund_reason} />
            <InfoRow
              label="Parent Connected?"
              // value={rowData?.is_parent_connected ? 'Yes' : 'No' || rowData?.parent_connected ? 'Yes' : 'No'}
              value={
                Number(rowData?.is_parent_connected) === 1 || Number(rowData?.parent_connected) === 1 ? 'Yes' : 'No'
              }
            />
            {/* <InfoRow
              label="EMI Student?"
              value={rowData?.emi_student ? 'Yes' : 'No'}
            /> */}
            <InfoRow label="Request Raised Date" value={rowData?.expense_timestamp} />
            <InfoRow label="Parent Requested Date" value={rowData?.parent_requested_date || 'N/A'} />

            <InfoRow
              label="Requested By"
              // value={typeof rowData?.raisedBy === 'number' ? rowData?.raisedByName : rowData?.raisedBy}
              value={
                rowData?.raisedByName && typeof rowData?.raisedByName == 'string'
                  ? rowData?.raisedByName
                  : rowData?.raisedBy
              }
            />
          </Grid>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
            <AccountBalance sx={{ fontSize: 20, mr: 1, verticalAlign: 'middle' }} />
            Bank Account Details
          </Typography>
          <Grid container spacing={2}>
            <InfoRow label="Account Number" value={rowData?.account_number || rowData?.refund_ac_no} />
            <InfoRow label="Account Holder Name" value={rowData?.account_holder_name || rowData?.refund_ac_holder} />
            <InfoRow label="IFSC Code" value={rowData?.ifsc_code || rowData?.refund_ifsc} />
          </Grid>
        </Box>

        {rowData?.requested_remarks && (
          <>
            <Divider sx={{ my: 3 }} />
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>
                Remarks:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1,
                  fontStyle: 'italic',
                }}
              >
                {rowData.requested_remarks}
              </Typography>
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default RequestInfo;
